// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__16cOJ","inputWrap":"CustomTip_inputWrap__21C9R"};